module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "handlers"
  }, [_c('a', {
    attrs: {
      "href": _vm.telephoneAttribute
    }
  }, [_c('span', {
    staticClass: "fa fa-phone"
  }), _vm._v(" " + _vm._s(_vm.telephone))]), _vm._v(" "), _c('span', {
    staticClass: "trigger",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.expand()
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.expanded),
      expression: "!expanded"
    }],
    staticClass: "openLabel"
  }, [_vm._v("OPEN MENU")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expanded),
      expression: "expanded"
    }],
    staticClass: "closeLabel"
  }, [_vm._v("CLOSE MENU")]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-bars"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-15a91763!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/src/components/Navigation/NavigationHandler.vue
// module id = 410
// module chunks = 0